import { type FC, useContext } from "react";
import { DragDropEditorContext, type DragDropSettingsProps } from "../../DragDropTypes";

export const SpacerComponentSettings: FC<DragDropSettingsProps> = ({
    id,
    value,
}) => {
    const { manager } = useContext(DragDropEditorContext);

    return (
        <label className="block">
            Height
            <input
                type="number"
                min="0"
                step="1"
                value={value as string}
                onChange={e => {
                    manager.updateComponent(id, e.currentTarget.value);
                }}
            />
        </label>
    );
};
